import React from 'react';
import { IoIosArrowForward } from 'react-icons/io';
import { Link } from 'react-router-dom';

export interface TailwindTooltipProps {
	link?: string;
	firstItem?: boolean;
	children: string;
}

export function BreadcrumbsItem({ link, firstItem, children }: TailwindTooltipProps) {
	return (
		<li className='inline-flex items-center leading-5'>
			{!firstItem && <IoIosArrowForward className='w-4 h-4 mx-1 text-gray-500' />}

			{link ? (
				<Link
					className='leading-5 underline decoration-2 underline-offset-2 decoration-gray-300 hover:text-black hover:decoration-black transition-colors hover:underline hover:decoration-2'
					to={link}
				>
					{children}
				</Link>
			) : (
				<strong className='leading-5 font-normal'>{children}</strong>
			)}
		</li>
	);
}
